import { Card, CardContent } from '@/common/ui/card'
import { Badge } from '@/common/ui/badge'
import { Check, Gift, Sparkles } from 'lucide-react'
import { RewardType } from './types'

interface Step2RewardTypeProps {
	selectedType: RewardType | null
	onSelect: (type: RewardType) => void
	onNext: () => void
}

export default function Step2RewardType({
	selectedType,
	onSelect,
	onNext,
}: Step2RewardTypeProps) {
	const handleSelect = (type: RewardType) => {
		onSelect(type)
		// Auto-advance after a short delay for visual feedback
		setTimeout(() => {
			onNext()
		}, 300)
	}
	return (
		<div className="space-y-6">
			<div className="text-center">
				<h2 className="text-xl font-bold">เลือกประเภทของรางวัล</h2>
			</div>

			<div className="grid gap-4 md:grid-cols-2">
				{/* PROMOTION - With Conditions */}
				<Card
					className={`cursor-pointer transition-all hover:shadow-lg ${
						selectedType === 'promotion'
							? 'border-primary bg-primary/5 ring-2 ring-primary'
							: 'hover:border-primary/50'
					}`}
					onClick={() => handleSelect('promotion')}
				>
					<CardContent className="p-5">
						<div className="flex items-start justify-between">
							<div className="flex items-center gap-3">
								<div className="rounded-lg bg-orange-500 p-2.5">
									<Gift className="h-5 w-5 text-white" />
								</div>
								<div>
									<h3 className="text-lg font-bold">โปรโมชั่น</h3>
									<Badge variant="outline" className="mt-1 text-xs">
										มีเงื่อนไข
									</Badge>
								</div>
							</div>
							{selectedType === 'promotion' && (
								<div className="rounded-full bg-primary p-1">
									<Check className="h-4 w-4 text-white" />
								</div>
							)}
						</div>

						<div className="mt-4 space-y-2">
							<div className="rounded-lg border-2 border-dashed border-orange-300 bg-orange-50 p-3 dark:border-orange-700 dark:bg-orange-950">
								<p className="text-center text-sm font-bold text-orange-700 dark:text-orange-300">
									เข้ากระเป๋าเงินติดเงื่อนไข
								</p>
							</div>

							<div className="flex flex-wrap gap-1.5">
								<Badge variant="secondary" className="text-xs">
									Min/Max ถอน
								</Badge>
								<Badge variant="secondary" className="text-xs">
									จำกัดเกม หรือ ค่ายเกม
								</Badge>
								<Badge variant="secondary" className="text-xs">
									เทิร์นโอเวอร์
								</Badge>
							</div>
						</div>
					</CardContent>
				</Card>

				{/* FREE CREDIT - No Conditions */}
				<Card
					className={`cursor-pointer transition-all hover:shadow-lg ${
						selectedType === 'credit'
							? 'border-primary bg-primary/5 ring-2 ring-primary'
							: 'hover:border-primary/50'
					}`}
					onClick={() => handleSelect('credit')}
				>
					<CardContent className="p-5">
						<div className="flex items-start justify-between">
							<div className="flex items-center gap-3">
								<div className="rounded-lg bg-green-500 p-2.5">
									<Sparkles className="h-5 w-5 text-white" />
								</div>
								<div>
									<h3 className="text-lg font-bold">เครดิตฟรี</h3>
									<Badge variant="outline" className="mt-1 text-xs">
										ไม่มีเงื่อนไข
									</Badge>
								</div>
							</div>
							{selectedType === 'credit' && (
								<div className="rounded-full bg-primary p-1">
									<Check className="h-4 w-4 text-white" />
								</div>
							)}
						</div>

						<div className="mt-4 space-y-2">
							<div className="rounded-lg border-2 border-dashed border-green-300 bg-green-50 p-3 dark:border-green-700 dark:bg-green-950">
								<p className="text-center text-sm font-bold text-green-700 dark:text-green-300">
									เข้ากระเป๋า
								</p>
							</div>

							<div className="flex flex-wrap gap-1.5">
								<Badge variant="secondary" className="text-xs">
									ไม่มีเทิร์นโอเวอร์
								</Badge>
								<Badge variant="secondary" className="text-xs">
									เล่นเกมอะไรก็ได้
								</Badge>
								<Badge variant="secondary" className="text-xs">
									ถอนได้ทันที
								</Badge>
							</div>
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	)
}
